const SpeechScoreRanges = [
    { min: 0, max: 3.99, level: 1 },
    { min: 4, max: 6, level: 0 },
    { min: 6.01, max: 10, level: -1 },
];
export const getSpeechScore = (eventDate) => {
    try {
        if (eventDate == null) {
            console.error("EventDate hasn't been provided");
            return null;
        }

        let result = {};

        const score = eventDate.speech?.score;
        const averageScore = eventDate.speech?.averageScore;
        const isVotingMember = eventDate.speech?.isVotingMember;

        const scoreLevel = getSpeechScoreRange(score);
        const averageScoreLevel = getSpeechScoreRange(averageScore);

        result.score = score;
        result.scoreLevel = scoreLevel;
        result.averageScore = averageScore;
        result.averageScoreLevel = averageScoreLevel;
        result.isVotingMember = isVotingMember;

        return result;
    } catch (error) {
        console.error("speech-score:" + error);
        return null;
    }
};

const getSpeechScoreRange = (score) => {
    if (score == null || isNaN(score)) return null;

    const matchingRange = SpeechScoreRanges.find(
        (range) => score >= range.min && score <= range.max
    );

    return matchingRange ? matchingRange.level : null;
};
